import { Card, CardBody, Badge } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import type { components } from '../../../Api/types/openapi';

type CaseStatusHistoryUSCISResponse = components['schemas']['CaseStatusHistoryUSCISResponse'];

interface CaseHistoryTimelineProps {
  histories: CaseStatusHistoryUSCISResponse[];
}

const CaseHistoryTimeline: React.FC<CaseHistoryTimelineProps> = ({ histories }) => {
  const { t } = useTranslation();

  if (!histories || histories.length === 0) {
    return (
      <Card>
        <CardBody>
          <p className="text-muted text-center">{t('Sin historial disponible')}</p>
        </CardBody>
      </Card>
    );
  }

  // Ordenar por fecha (más reciente primero)
  const sortedHistories = [...histories].sort((a, b) => {
    const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
    const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
    return dateB - dateA;
  });

  return (
    <Card>
      <CardBody>
        <h5 className="mb-4">{t('Historial de Casos')}</h5>
        <div className="timeline-widget">
          {sortedHistories.map((history, index) => (
            <div key={history.id || index} className="activity-item">
              <div className="activity-user">
                <div className="avatar-sm rounded-circle bg-light-primary text-primary d-flex align-items-center justify-content-center">
                  <i className="fa fa-file-text" />
                </div>
              </div>
              <div className="activity-content">
                <div className="timeline-list-item">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      {history.created_at && (
                        <p className="mb-1">
                          <strong>{new Date(history.created_at).toLocaleString('es-ES')}</strong>
                        </p>
                      )}
                      {history.comment && (
                        <p className="mb-2">{history.comment}</p>
                      )}
                      {history.obj_uscis_response && (
                        <div className="mt-2">
                          <Badge color="info" className="mb-2">
                            {t('Respuesta USCIS')}
                          </Badge>
                          <div className="bg-light p-2 rounded" style={{ fontSize: '0.85rem' }}>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                              {JSON.stringify(history.obj_uscis_response, null, 2)}
                            </pre>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default CaseHistoryTimeline;

